import React, { Component } from "react";
import { Modal, Table } from "antd";
import Wrapper from "@comm/DataWrapper";
import util from "@util/index";

class ModalDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  columns = () => {
    return [
      {
        title: "姓名",
        dataIndex: "name",
      },
      {
        title: "税前年终奖",
        dataIndex: "pretax",
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "个税",
        dataIndex: "personalTax",
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
      {
        title: "实发年终奖",
        dataIndex: "netPay",
        render: text => <span>{util.numberFormat(text, 2, ".", ",")}</span>,
      },
    ];
  };

  render() {
    const { dataList, pagination, visible } = this.props;
    return (
      <Modal
        width={900}
        title="年终奖明细详情"
        visible={visible}
        footer={false}
        onCancel={() => this.props.onCancel(false)}
      >
        <Table
          rowKey="uuid"
          columns={this.columns()}
          dataSource={dataList}
          pagination={pagination}
        />
      </Modal>
    );
  }
}

export default Wrapper(ModalDetailTable);



// WEBPACK FOOTER //
// ./src/components/hr/bonus/ModalDetailTable.js